export const breadcrumbs = [
  {
    text: "Главная",
    disabled: false,
    href: "/",
  },
  {
    text: "Справочники: Справочник фондов",
    disabled: true,
    href: "breadcrumbs_link_1",
  },
];
